import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { QueryResponse } from '../../core/services/QueryResponse';
import { ModuleListModel } from '../models/ModuleListModel';
import { RuleModel } from '../models/RuleModel';
import { RuleListModel } from '../models/RuleListModel';
import { RuleCommonParameterModel } from '../models/RuleCommonParameterModel';
import { UpdateRuleParameterModel } from '../models/UpdateRuleParameterModel';
import { ModelResponse } from '../../core/services/ModelResponse';
import { RuleParameterModel } from '../models/RuleParameterModel';
import { ParameterModel } from "../models/ParameterModel";
import { BaseAddressInterceptor } from '../../core/interceptors/BaseAddressInterceptor';
import { ExportRuleModel } from '../models/ExportRuleModel';

@Injectable()
export class RuleService {

  constructor(
    private httpClient: HttpClient,
    private baseAddressInterceptor: BaseAddressInterceptor ) { }

  getRuleList(page: number, pageSize: number, sort: string, sortDirection: string, searchTerm: string): Observable<QueryResponse<ModuleListModel>> {
    var params = new HttpParams()
      .set('skip', (page * pageSize).toString())
      .set('take', pageSize.toString());
    if (sort) {
      params = params
        .set('sort', sort)
        .set('sortDirection', sortDirection);
    }
    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
    }
    return this.httpClient.get<QueryResponse<ModuleListModel>>('/api/BusinessRule/ListQuery', { params: params });
  }

  getRuleListByModule(moduleName: string, page: number, pageSize: number, sort: string, sortDirection: string, searchTerm: string): Observable<QueryResponse<ModuleListModel>> {
    var params = new HttpParams()
      .set('moduleName', (moduleName))
      .set('skip', (page * pageSize).toString())
      .set('take', pageSize.toString());
    if (sort) {
      params = params
        .set('sort', sort)
        .set('sortDirection', sortDirection);
    }
    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
    }
    return this.httpClient.get<QueryResponse<ModuleListModel>>('/api/BusinessRule/Get/' + moduleName, { params: params });
  }

  enableRule(model: RuleListModel): Observable<ModelResponse<boolean>> {
    return this.httpClient.post<ModelResponse<boolean>>("/api/BusinessRule/EnableRule/", model);
  }

  disableRule(model: RuleListModel): Observable<ModelResponse<boolean>> {
    return this.httpClient.post<ModelResponse<boolean>>("/api/BusinessRule/DisableRule/", model);
  }

  updateRuleStatus(model: RuleModel): Observable<ModelResponse<boolean>> {
    return this.httpClient.post<ModelResponse<boolean>>("/api/BusinessRule/UpdateRule/", model);
  }

  updateRuleParameter(rule: RuleListModel, parameter: RuleParameterModel) {
    return this.httpClient.post<ModelResponse<boolean>>("/api/BusinessRule/UpdateRuleParameter/", { rule: rule, parameter: parameter });
  }

  exportRules(model: ExportRuleModel): Observable<ModelResponse<ExportRuleModel>> {
    return this.httpClient.post<ModelResponse<ExportRuleModel>>(`/api/BusinessRule/ExportUrl/`, model)
      .map(r => {
        r.model.url = this.baseAddressInterceptor.getApiUrl(r.model.url);
        return r;
      });
  }

  getRelatedDataSets(model: RuleModel): Observable<ModelResponse<string[]>> {
    return this.httpClient.post<ModelResponse<string[]>>("/api/BusinessRule/GetRelatedDataSets", model);
  }

  getComparisonDate(model: RuleCommonParameterModel): Observable<ModelResponse<string[]>> {
    return this.httpClient.post<ModelResponse<string[]>>("/api/BusinessRule/GetComparisonDate", model);
  }

  applyCommonParameters(model: RuleCommonParameterModel): Observable<ModelResponse<RuleCommonParameterModel>> {
    return this.httpClient.post<ModelResponse<RuleCommonParameterModel>>("/api/BusinessRule/ApplyCommonParameters", model);
  }

  openExtract(url: string, model: any): void {
    var mapForm = document.createElement("form");
    mapForm.target = "_blank";
    mapForm.method = "POST"; // or "post" if appropriate
    mapForm.action = url;
    Object.keys(model).forEach((param) => {
      var value = model[param];
      if (Array.isArray(value)) {
        var select = document.createElement("select");
        select.multiple = true;
        select.name = param;
        value.forEach((v) => {
          var option = document.createElement("option");
          select.add(option);
          option.setAttribute("value", v);
          option.selected = true;
        });
        mapForm.appendChild(select);
      } else {
        var mapInput = document.createElement("input");
        mapInput.type = "hidden";
        mapInput.name = param;
        mapInput.setAttribute("value", value);
        mapForm.appendChild(mapInput);
      }
    });
    document.body.appendChild(mapForm);
    mapForm.submit();
    setTimeout(() => document.body.removeChild(mapForm), 100);
  }
}



// WEBPACK FOOTER //
// ./src/app/businessRule/services/RuleService.ts